import { createRouter, createWebHashHistory } from 'vue-router'
import RouterView from '@/components/RouterView.vue'
import { setupRouterGuards } from './guards'

const manageAuth = { requiresAuth: true, authRole: 'manage' }
const riderAuth = { requiresAuth: true, authRole: 'rider' }
const deliverAuth = { requiresAuth: true, authRole: 'deliver' }

const router = createRouter({
  // history: createWebHashHistory(import.meta.env.BASE_URL),
  // history: createWebHistory(),
  history: createWebHashHistory(import.meta.env.VITE_PATH),
  routes: [
    {
      path: '/',
      redirect: '/home',
      component: RouterView,
    },
    {
      path: '/home',
      name: 'home',
      meta: manageAuth,
      component: () => import('../views/HomeView.vue')
    },
    {
      path: '/user',
      name: 'user',
      meta: manageAuth,
      component: () => import('../views/UserView.vue'),
    },
    {
      path: '/orderList',
      name: 'orderlist',
      meta: manageAuth,
      component: () => import('../views/OrderList.vue'),
    },
    {
      path: '/devicelist',
      name: 'devicelist',
      meta: manageAuth,
      component: () => import('../views/deviceList.vue'),
    },
    {
      path: '/stockList',
      name: 'stockList',
      meta: manageAuth,
      component: () => import('../views/stockList.vue'),
    },
    {
      path: '/purchOrder',
      name: 'purchOrder',
      meta: manageAuth,
      component: () => import('../views/purchOrder.vue'),
    },
    {
      path: '/goodsManage',
      name: 'goodsManage',
      meta: manageAuth,
      component: () => import('../views/goodsManage.vue'),
    },
    {
      path: '/purgoods',
      name: 'purgoods',
      meta: manageAuth,
      component: () => import('../views/purchaseGoods.vue'),
    },
    {
      path: '/deliveryCenter',
      name: 'deliveryCenter',
      meta: manageAuth,
      component: () => import('../views/deliveryCenter.vue'),
    },
    {
      path: '/riderCenter',
      name: 'riderCenter',
      meta: manageAuth,
      component: () => import('../views/riderCenter.vue'),
    },
    {
      path: '/deliveryPersonCenter',
      name: 'deliveryPersonCenter',
      meta: deliverAuth,
      component: () => import('../views/deliveryPersonCenter.vue'),
    },
    {
      path: '/deliveryPersonList',
      name: 'deliveryPersonList',
      meta: manageAuth,
      component: () => import('../views/deliveryPersonList.vue'),
    },
    {
      path: '/deliverPersondia',
      name: 'deliverPersondia',
      meta: manageAuth,
      component: () => import('../views/components/deliverPersondia.vue'),
    },
    {
      path: '/login',
      name: 'login',
      component: () => import('../components/Login.vue'),
    },
    {
      path: '/deliveryLogin',
      name: 'deliveryLogin',
      component: () => import('../components/deliveryPersonLogin.vue'),
    },
    // 新增门店注册路由
    {
      path: '/signin',
      name: 'signin',
      component: () => import('../components/Signin.vue')
    },
    // 修改门店注册信息
    {
      path: '/editSignin',
      name: 'editSignin',
      meta: manageAuth,
      component: () => import('../components/editSignin.vue')
    },

    //骑手登录
    {
      path: '/riderLogin',
      name: 'riderLogin',
      component: () => import('../components/riderLogin.vue'),
    },
    {
      path: '/riderSignin',
      name: 'riderSignin',
      component: () => import('../components/riderSignin.vue'),
    },
    // 骑手页面
    {
      path: '/riderHome',
      name: 'riderHome',
      meta: riderAuth,
      component: () => import('../views/riderHome.vue')
    },
    {
      path: '/riderMy',
      name: 'riderMy',
      meta: riderAuth,
      component: () => import('../views/riderMy.vue')
    },
    {
      path: '/userSettings',
      name: 'userSettings',
      meta: manageAuth,
      component: () => import('../views/userSettings.vue')
    },
    {
      path: '/riderBalance',
      name: 'riderBalance',
      meta: riderAuth,
      component: () => import('../views/riderBalance.vue'),
    },
    {
      path: '/riderInfo',
      name: 'riderInfo',
      meta: riderAuth,
      component: () => import('../views/riderInfo.vue')

    },
    {
      path: '/income',
      name: 'income',
      meta: manageAuth,
      component: () => import('../views/IncomeView.vue'),
    },
    {
      path: '/incomedetails',
      name: 'incomedetails',
      meta: manageAuth,
      component: () => import('../views/IncomeDetails.vue'),
    },
    {
      path: '/subsidyvoucher',
      name: 'subsidyvoucher',
      meta: manageAuth,
      component: () => import('../views/SubsidyVoucher.vue'),
    },
    {
      path: '/setStoreAvatar',
      name: 'setStoreAvatar',
      meta: manageAuth,
      component: () => import('../views/setStoreAvatar.vue')
    },
    {
      path: '/editStoreName',
      name: 'editStoreName',
      meta: manageAuth,
      component: () => import('../views/EditStoreName.vue')
    },
    {
      path: '/editStoreAddress',
      name: 'editStoreAddress',
      meta: manageAuth,
      component: () => import('../views/EditStoreAddress.vue')
    },
    {
      path: '/changePassword',
      name: 'changePassword',
      meta: manageAuth,
      component: () => import('../views/ChangePassword.vue')
    },
    {
      path: '/goodsDetail',
      name: 'goodsDetail',
      meta: manageAuth,
      component: () => import('@/views/goodsDetail.vue')
    },
    // 添加帮我推广页面的路由
    {
      path: '/promotion',
      name: 'Promotion',
      component: () => import('@/views/components/promotion.vue'),
      meta: {
        title: '帮我推广',
        ...manageAuth,
      }
    },
    {
      path: '/messageCenter',
      name: 'messageCenter',
      component: () => import('@/views/messageCenter/index.vue'),
      meta: {
        title: '消息中心',
        ...manageAuth,
      }
    },
    {
      path: '/messageCenter/detail',
      name: 'messageDetail',
      component: () => import('@/views/messageCenter/detail.vue'),
      meta: {
        title: '消息详情',
        ...manageAuth,
      }
    },
    // 添加补贴奖励页面的路由
    {
      path: '/subsidy',
      name: 'subsidy',
      component: () => import('@/views/SubsidyView.vue'),
      meta: {
        title: '补贴奖励',
        ...manageAuth,
      }
    },
    {
      path: '/activity',
      name: 'activity',
      component: () => import('@/views/components/NearActivity.vue'),
      meta: {
        title: '门店活动',
        ...manageAuth,
      }
    },
    {
      path: '/contractList',
      name: 'contractList',
      component: () => import('@/views/contractList.vue'),
      meta: {
        title: '签约',
        ...manageAuth,
      }
    },
    {
      path: '/deduction',
      name: 'deduction',
      component: () => import('@/views/deduction.vue'),
      meta: {
        title: '扣款记录',
        ...manageAuth,
      }
    },
    {
      path: '/aiAnalyze',
      name: 'aiAnalyze',
      component: () => import('@/views/aiAnalyze.vue'),
      meta: {
        title: 'AI经营中心',
        ...manageAuth,
      }
    },
	{
	  path: '/aiTakeCare',
	  name: 'aiTakeCare',
	  component: () => import('@/views/aiTakeCare.vue'),
	  meta: {
	    title: 'AI看店',
	    ...manageAuth,
	  }
	},
	{
	  path: '/visitrecord',
	  name: 'visitrecord',
	  component: () => import('@/views/visitrecord.vue'),
	  meta: {
	    title: '到访记录',
	    ...manageAuth,
	  }
	},
	{
	  path: '/visitvideo',
	  name: 'visitvideo',
	  component: () => import('@/views/visitvideo.vue'),
	  meta: {
	    title: '访客到访视频',
	    ...manageAuth,
	  }
	},
    {
      path: '/qrCode',
      name: 'qrCode',
      component: () => import('@/views/qrCode.vue'),
      meta: {
        title: '收款码',
        ...manageAuth,
      }
    },
    {
      path: '/deliveryAndRider',
      name: 'deliveryAndRider',
      meta: manageAuth,
      component: () => import('@/views/deliveryAndRider.vue'),
    }, {
      path: '/scanToPick',
      name: 'scanToPick',
      meta: { requiresAuth: false },
      component: () => import('@/views/scanToPick/scanToPickUp.vue'),
    },{
      path: '/scanCode',
      name: 'scanCode',
      meta: manageAuth,
      component: () => import('@/views/scanCode.vue'),
    },{
      path: '/scanCoder',
      name: 'scanCode1',
      meta: manageAuth,
      component: () => import('@/views/scanCode1.vue'),
    },
    {
      path: '/activityPage',
      name: 'activityPage',
      component: () => import('@/views/activety/activityPage.vue'),
      meta: {
        title: '排行榜',
        requiresAuth: false
      }
    },
    {
      path: '/proAreaDetail',
      name: 'proAreaDetail',
      component: () => import('@/views/activety/proAreaDetail.vue'),
      meta: {
        title: '产区排行榜',
        requiresAuth: false
      }
    },
    {
      path: '/brandDetail',
      name: 'brandDetail',
      component: () => import('@/views/activety/brandDetail.vue'),
      meta: {
        title: '商品详情',
        requiresAuth: false
      }
    },
    {
      path: '/waterRank',
      name: 'waterRank',
      component: () => import('@/views/activety/waterRank.vue'),
      meta: {
        title: '水榜单',
        requiresAuth: false
      }
    },
  ]
})

setupRouterGuards(router)

export default router
